type Adres = { protocol: string; host: string; pathname: string };

/**
 * Adres logowania w portalu tenanta (logowanie jest wylacznie tam):
 * - modul pod wlasna subdomena: zamowienia.<tenant>.iconcret.pl -> <protokol>//<tenant>.iconcret.pl/
 * - modul pod sciezka /zamowienia (dev-local: zamdev.localhost/zamowienia) -> korzen tego samego hosta.
 * null, gdy portalu nie da sie wskazac (sam localhost albo adres IP w dev) - przekierowanie
 * zapetliloby wtedy strone modulu.
 */
export function adresLogowaniaPortalu({ protocol, host, pathname }: Adres): string | null {
  if (pathname === '/zamowienia' || pathname.startsWith('/zamowienia/')) return `${protocol}//${host}/`;
  const [modul, ...reszta] = host.split('.');
  if (modul !== 'zamowienia' || reszta.length < 2) return null;
  return `${protocol}//${reszta.join('.')}/`;
}

/** Przechodzi do logowania w portalu; false, gdy nie ma dokad (patrz wyzej). */
export function przekierujDoLogowania(): boolean {
  const adres = adresLogowaniaPortalu(window.location);
  if (!adres) return false;
  window.location.assign(adres);
  return true;
}
